export default __webpack_public_path__ + "static/hero-bg-right-2e1131ffcf693b03fcdc988efb7ab84e.png";